import Nav from 'react-bootstrap/Nav';
import { NavLink, useLocation } from 'react-router-dom';
import './navigation-button.component.scss';
import { NavigationButtonComponentProps } from './navigation-button-props.interface';
import { NavigationIcon } from './navigation-icon.component';

export const NavigationButtonComponent = ({
  children,
  path,
  id,
  name,
  icon,
  IconComponent = <NavigationIcon icon={icon} name={name} />,
  className,
}: NavigationButtonComponentProps) => {
  const { search } = useLocation();

  return (
    <Nav.Link
      eventKey={id}
      active={false}
      as={NavLink}
      to={`${path}${search}`}
      className={className}
    >
      {IconComponent}
      <div className="">{name}</div>
      {children}
    </Nav.Link>
  );
};
